import Button from "legacy/LegacyButton"
import { titleCase } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: Amplitude is loaded globally, not via an import

class AvailabilityDailyModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.categoryDetails = this.categoryDetails.bind(this)
    this.spaceGroupHistogram = this.spaceGroupHistogram.bind(this)
  }

  openModal() {
    if (this.props.showingTonightsBoats) {
      Amplitude.trackEvent(
        "tonights_boats:availability_see_more_details_clicked",
        {
          marina_name: this.props.marinaName,
          marina_id: this.props.marinaMcomId,
        }
      )
    }

    Amplitude.trackEvent("availability_daily_modal:opened", {
      marina_name: this.props.marinaName,
      marina_id: this.props.marinaMcomId,
    })

    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  modalButton() {
    return (
      <Button type="secondary" onClick={this.openModal}>
        See more details
      </Button>
    )
  }

  containsLinearSpaceGroup(data) {
    const linearDocks = (data || []).filter((spaceGroupData) =>
      ["SpaceGroup::Linear", "SpaceGroup::LinearV2"].includes(
        spaceGroupData.type
      )
    )
    return linearDocks && linearDocks.length > 0
  }

  spaceGroupHistogram(spaceGroupData) {
    // Calculate inventory total based on type
    let total
    if (spaceGroupData.type === "SpaceGroup::SquareFootage") {
      total = Math.ceil(spaceGroupData.inventory_total / 144) // inchesToSquareFeet
    } else if (spaceGroupData.type.includes("SpaceGroup::Linear")) {
      total = Math.ceil(spaceGroupData.inventory_total / 12) // inchesToFeet
    } else {
      total = spaceGroupData.inventory_total
    }

    // Calculate occupancies total based on type
    let count = 0
    const nightsValues = Object.values(spaceGroupData.nights || {})
    const nightData = nightsValues.length > 0 ? nightsValues[0] : null

    if (nightData) {
      if (spaceGroupData.type === "SpaceGroup::SquareFootage") {
        count = Math.ceil(nightData.square_inches / 144) // inchesToSquareFeet
      } else if (spaceGroupData.type.includes("SpaceGroup::Linear")) {
        count = Math.ceil(nightData.loa / 12) // inchesToFeet
      } else {
        count = nightData.count || 0
      }
    }

    const remaining = Math.floor(total - count)

    // Get unit symbol based on type
    let unitSymbol = ""
    switch (spaceGroupData.type) {
      case "SpaceGroup::SquareFootage":
        unitSymbol = "sqft"
        break
      case "SpaceGroup::Linear":
      case "SpaceGroup::LinearV2":
        unitSymbol = "'"
        break
      default:
        unitSymbol = ""
    }
    const remainingString = `${remaining}${unitSymbol}`

    return (
      <div key={spaceGroupData.name} className="mx-1 w-full lg:w-60">
        <div className="flex flex-row justify-between">
          <h5 className="font-semibold">{spaceGroupData.name}</h5>
          <h5 className="text-muted">
            {total}
            {unitSymbol} total
          </h5>
        </div>
        <div
          className="btn btn-primary btn-sm w-full"
          onClick={() => {
            window.location.href = this.props.todayRoute
          }}
        >
          {remainingString} remaining
        </div>
      </div>
    )
  }

  categoryDetails(category, data) {
    return (
      <div
        key={category.replace(" ", "-")}
        className="bg-gray mx-2 mb-2 flex flex-col rounded p-4"
      >
        <h4 className="align-center flex">
          {titleCase(category)}
          {this.containsLinearSpaceGroup(data) ? (
            <i
              className="fa-solid fa-circle-info ml-2 mt-0.5 cursor-pointer text-xs text-gray-500"
              data-container="body"
              data-toggle="popover"
              data-placement="top"
              data-content="Buffer is included in the calculation for linear dockage."
            />
          ) : null}
        </h4>
        <div className="flex flex-row flex-wrap">
          {(data || []).map((spaceGroupData, index) => (
            <div key={spaceGroupData.name || `space-group-${index}`}>
              {this.spaceGroupHistogram(spaceGroupData)}
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="inline">
        {this.modalButton()}
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="large"
          maxWidth="55rem"
        >
          <Modal.Header title={`Availability for ${this.props.night}`} />
          <Modal.Body>
            <div>
              {Object.entries(this.props.availabilityByCategory || {}).map(
                ([category, data]) => (
                  <div key={category}>
                    {this.categoryDetails(category, data)}
                  </div>
                )
              )}
            </div>
          </Modal.Body>
          <Modal.Footer
            onlyCancel={true}
            cancelBtnText="Close"
            onClose={this.closeModal}
          />
        </Modal>
      </div>
    )
  }
}

AvailabilityDailyModal.propTypes = {
  availabilityByCategory: PropTypes.object.isRequired,
  marinaName: PropTypes.string,
  marinaMcomId: PropTypes.string,
  night: PropTypes.string.isRequired,
  showingTonightsBoats: PropTypes.bool,
  todayRoute: PropTypes.string.isRequired,
}

export default AvailabilityDailyModal
